
import { defineComponent, onMounted, onUpdated, reactive, toRefs,watch } from "vue";
import { getMyData } from "../../../../api/user";
import { useRouter,useRoute ,createRouter } from 'vue-router'
import { dataType } from "./stateType";
import { Toast } from "vant";

const states: dataType = {
  userData: {},
};
export default defineComponent({
  setup() {
    const state = reactive<dataType>(states);
    const router = useRouter()
    const { getUserData } = useNextwork(state);
    const { onResource, onFeedback,toMyInfo } = useEvent(state,router);
    onMounted(() => {
      getUserData();
    });
    
    return {
      ...toRefs(state),
      onResource,
      onFeedback,
      toMyInfo
    };
  },
  components: {},
});

// 事件类hooks
const useEvent = (state: dataType,router:any) => {
  const onResource = () => {
    Toast({
      message: "敬请期待",
    });
  };

  const onFeedback = () => {
    location.href = "https://support.qq.com/product/343845";
  };
  const toMyInfo = ()=>{
    router.push('/myInfo')
  }

  return {
    onFeedback,
    onResource,
    toMyInfo
  };
};

// 接口相关hooks
const useNextwork = (state: dataType) => {
  const getUserData = async () => {
    const result: any = await getMyData();
    if (result.data.code == 0) {
      state.userData = result.data.data;
      if(state.userData.imgs.length == 0){
        state.userData.imgs = null
      }
    }
  };
  return {
    getUserData,
  };
};
